export default __webpack_public_path__ + "72ffd79d393e1753fd5afe9428a00ec0.png";